import { render, staticRenderFns } from "./VoidCharge.vue?vue&type=template&id=36b5b4d6&lang=pug"
import script from "./VoidCharge.vue?vue&type=script&lang=js"
export * from "./VoidCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports